var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2.5C4.10218 2.5 3.72064 2.65804 3.43934 2.93934C3.15804 3.22065 3 3.60218 3 4V17C3 17.3978 3.15804 17.7794 3.43934 18.0607C3.72064 18.342 4.10218 18.5 4.5 18.5H15.5C15.8978 18.5 16.2794 18.342 16.5607 18.0607C16.842 17.7794 17 17.3978 17 17V8.121C16.9997 7.72331 16.8414 7.34204 16.56 7.061L12.44 2.939C12.3005 2.79961 12.1349 2.6891 11.9527 2.61377C11.7705 2.53844 11.5752 2.49978 11.378 2.5H4.5ZM6.75 11C6.55109 11 6.36032 11.079 6.21967 11.2197C6.07902 11.3603 6 11.5511 6 11.75C6 11.9489 6.07902 12.1397 6.21967 12.2803C6.36032 12.421 6.55109 12.5 6.75 12.5H13.25C13.4489 12.5 13.6397 12.421 13.7803 12.2803C13.921 12.1397 14 11.9489 14 11.75C14 11.5511 13.921 11.3603 13.7803 11.2197C13.6397 11.079 13.4489 11 13.25 11H6.75ZM6.75 14C6.55109 14 6.36032 14.079 6.21967 14.2197C6.07902 14.3603 6 14.5511 6 14.75C6 14.9489 6.07902 15.1397 6.21967 15.2803C6.36032 15.421 6.55109 15.5 6.75 15.5H13.25C13.4489 15.5 13.6397 15.421 13.7803 15.2803C13.921 15.1397 14 14.9489 14 14.75C14 14.5511 13.921 14.3603 13.7803 14.2197C13.6397 14.079 13.4489 14 13.25 14H6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/aboutIcon.0c86cf1d14b8e8b7823b1d1713288a8d.svg";
export { ForwardRef as ReactComponent };